import React from 'react'
import { statusConfig, specialStatusKeys } from 'constants/orderStatusConfig'

export const useOrderSteps = (statuses, currentStatusKey) => {
  const isSpecialStatus = specialStatusKeys.includes(currentStatusKey)

  const steps = React.useMemo(() => {
    if (!statuses || statuses.length === 0) {
      return []
    }

    const getStep = status => ({
      key: status.key,
      label: statusConfig[status.key]?.label || status.title,
      icon: statusConfig[status.key]?.icon || 'fas fa-question-circle',
      shortLabel: statusConfig[status.key]?.shortLabel || status.title,
    })

    if (isSpecialStatus) {
      const orderPlacedStatus = statuses.find(s => s.key === 'order_placed')
      const currentSpecialStatus = statuses.find(
        s => s.key === currentStatusKey
      )
      const resultSteps = []

      if (orderPlacedStatus) {
        resultSteps.push(getStep(orderPlacedStatus))
      }

      if (currentSpecialStatus && currentStatusKey !== 'order_placed') {
        resultSteps.push(getStep(currentSpecialStatus))
      }
      return resultSteps
    }

    const regularStatuses = [
      'order_placed',
      'processing',
      'shipped',
      'delivering',
      'completed',
    ]

    return statuses
      .filter(s => regularStatuses.includes(s.key))
      .sort(
        (a, b) =>
          regularStatuses.indexOf(a.key) - regularStatuses.indexOf(b.key)
      )
      .map(getStep)
  }, [statuses, currentStatusKey, isSpecialStatus])

  return { steps, isSpecialStatus }
}
